
import { defineComponent, reactive, toRefs, ref, computed, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import moment from 'moment'
import { add, update, detail, dropdownOfEnterprise } from '../api'

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:visible', 'success'],
  setup(props, { emit }) {
    const formRef = ref(null)
    const dialogVisible = computed({
      get: () => props.visible,
      set: (val) => emit('update:visible', val)
    })
    
    const data = reactive({
      title: '新增',
      loading: false,
      enterpriseOptions: [] as any[],
      formData: {
        id: 0,
        type: 1,
        content: '',
        deadlineType: 1,
        deadline: '',
        scope: 1,
        enterprises: [] as number[], // Store company IDs
        url: '',
        status: 1
      },
      rules: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        deadlineType: [{ required: true, message: '请选择截止有效日期类型', trigger: 'change' }],
        scope: [{ required: true, message: '请选择范围', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    })

    const isUpgradeNotice = computed(() => {
      return data.formData.type === 1
    })

    const resetForm = () => {
      data.formData = {
        id: 0,
        type: 1,
        content: '',
        deadlineType: 1,
        deadline: '',
        scope: 1,
        enterprises: [] as number[],
        url: 'http://',
        status: 1
      }
      data.enterpriseOptions = []
      if (formRef.value) {
        (formRef.value as any).resetFields()
      }
    }

    const initData = async () => {
      if (props.rowData && props.rowData.id) {
        data.title = '编辑'
        try {
            const res = await detail({ id: props.rowData.id })
            if (res.data) {
                const d: any = res.data
                data.formData = {
                    id: d.id,
                    type: d.noticeType,
                    content: d.content,
                    deadlineType: d.isPermanent === 1 ? 1 : 2,
                    deadline: d.expireTime || '',
                    scope: d.filterRule,
                    enterprises: d.companies ? d.companies.map((company: any) => company.key) : [],
                    url: d.redirectUrl,
                    status: d.state
                }
                if (d.companies && d.companies.length > 0) {
                    data.enterpriseOptions = d.companies.map((company: any) => ({
                        label: company.value,
                        value: company.key
                    }))
                }
            }
        } catch (e) {
            console.error(e)
        }
      } else {
        data.title = '新增'
        resetForm()
      }
    }

    onMounted(() => {
      initData()
    })

    watch(() => data.formData.type, (newType) => {
      if (newType === 1) {
        // 当选择升级公告时，自动设置截止时间和公开全部
        data.formData.deadlineType = 2
        data.formData.scope = 1
      }
    })

    const handleClose = () => {
      emit('update:visible', false)
    }

    const remoteMethod = (query: string) => {
      if (query !== '') {
        data.loading = true
        dropdownOfEnterprise({ value: query, attached: true }).then((res: any) => {
          data.loading = false
          if (res.data) {
            data.enterpriseOptions = res.data.map((item: any) => ({
              label: item.value,
              value: item.attach.uuid
            }))
          }
        }).catch(() => {
          data.loading = false
        })
      } else {
        data.enterpriseOptions = []
      }
    }

    const handleSubmit = () => {
      (formRef.value as any).validate((valid: boolean) => {
        if (valid) {
            // Additional validation
            if (data.formData.deadlineType === 2 && !data.formData.deadline) {
                ElMessage.warning('请选择截止时间')
                return
            }
            if (data.formData.scope !== 1 && data.formData.enterprises.length === 0) {
                ElMessage.warning('请选择企业')
                return
            }
            if (data.formData.content.length > 2000) {
                ElMessage.warning('内容长度不能超过2000字符')
                return
            }
            if (data.formData.url.length > 128) {
                ElMessage.warning('链接长度不能超过128字符')
                return
            }

            const params = {
                id: data.formData.id,
                noticeType: data.formData.type,
                content: data.formData.content,
                state: data.formData.status,
                isPermanent: data.formData.deadlineType === 1 ? 1 : 0,
                expireTime: data.formData.deadlineType === 1 ? '' : moment(data.formData.deadline).format('YYYY-MM-DD HH:mm'),
                filterRule: data.formData.scope,
                companyUuids: data.formData.enterprises,
                redirectUrl: data.formData.url
            }
            
            const api = data.formData.id ? update : add
            api(params).then(() => {
                ElMessage.success('操作成功')
                emit('success')
                handleClose()
            })
        }
      })
    }

    return {
      ...toRefs(data),
      formRef,
      handleClose,
      handleSubmit,
      remoteMethod,
      dialogVisible,
      isUpgradeNotice
    }
  }
})
